import { useAuth } from "@/auth.tsx";
import { canManageAgent } from "@/components/agents/agent-card.tsx";
import { useAgentPolicy } from "@/components/agents/use-agent-policy.ts";
import { AgentBuilderForm } from "@/components/agents/agent-builder-form.tsx";
import { m } from "@/paraglide/messages.js";
import { agentDefinitionQueryOptions } from "@/services/agent-definitions-service.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/dashboard/agents/$agentId/edit",
)({
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.agent_builder_edit()) }],
	}),
});

function RouteComponent() {
	const { agentId } = Route.useParams();
	const { user } = useAuth();
	const { data } = useSuspenseQuery(agentDefinitionQueryOptions(agentId));
	// The server would 403 the save anyway; bounce viewers who cannot manage
	// this agent (org-wide agents deep-linked by non-admins) to the hub instead
	// of rendering a form that cannot be submitted.
	const policy = useAgentPolicy();
	if (!canManageAgent(data, user?.isAdmin ?? false, policy)) {
		return (
			<Navigate to="/dashboard/agents/$agentId" params={{ agentId }} replace />
		);
	}
	return <AgentBuilderForm agent={data} />;
}
